import type { LogLevel } from "@/types/wizard";

export function formatTimestamp(value: string | null | undefined): string {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      day: "2-digit",
      month: "short",
    });
  } catch {
    return value;
  }
}

export function formatRelative(value: string | null | undefined): string {
  if (!value) return "—";
  const parsed = new Date(value).getTime();
  if (Number.isNaN(parsed)) return "—";
  const diff = Date.now() - parsed;
  const seconds = Math.round(diff / 1000);
  if (seconds < 5) return "just now";
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 48) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  return `${days}d ago`;
}

export function mapOutcomeToLevel(outcome: string | null | undefined): LogLevel {
  const normalized = (outcome ?? "").toLowerCase();
  if (normalized.includes("fail") || normalized.includes("error")) return "error";
  if (normalized.includes("warn")) return "warn";
  if (
    normalized.includes("success") ||
    normalized.includes("created") ||
    normalized.includes("updated") ||
    normalized.includes("succeeded") ||
    normalized.includes("rotated") ||
    normalized.includes("configured")
  )
    return "success";
  return "info";
}

export function maskSecret(secret: string | null | undefined): string {
  if (!secret) return "—";
  if (secret.length <= 8) return "•".repeat(secret.length);
  return `${secret.slice(0, 4)}${"•".repeat(Math.min(20, secret.length - 8))}${secret.slice(-4)}`;
}
